import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import _ from 'lodash';
import { generatePath, useHistory } from 'react-router';

import { SliderItem } from 'api/main_page/public/get/params';
import { /* LINK_TYPE, */ SIZE_TYPE } from 'client/types';
import { COMPANY_PAGE_ROUTE, MANDATE_PAGE_ROUTE } from 'client/constants/routes';
// import LinkButton from '../LinkButton';
import { imgixUrl } from 'client/utils/imgix-url';
import { selectLang } from 'client/redux/settings/selectors';
import RatingUpButton from '../RatingUpButton';

import { useAppSelector, useAppDispatch } from 'client/hooks';

import { selectAuth, selectUserRole } from 'client/redux/user/selectors';

import css from './DoubleImageSlide.module.scss';
import PlayIcon from '../PlayIcon';

type Props = {
  className?: string;
  isUpvoteDisabled?: boolean;
  size?: SIZE_TYPE;
  buttonSize?: SIZE_TYPE;
  item: SliderItem;
  isMandateLink?: boolean;
  buttonLabel: string;
};

const DoubleImageSlide: React.FC<Props> = ({
  item,
  isUpvoteDisabled = false,
  size = SIZE_TYPE.SM,
  buttonSize = SIZE_TYPE.SM,
  className = '',
  isMandateLink = false,
  buttonLabel = '',
}) => {
  const lang = useAppSelector(selectLang);

  return (
    <div className={cn(css.doubleImageSlide, css[size], className)}>
      {isMandateLink && <div className={css.investmentStatus}>{item.mandateInfo?.investmentStatusTitle}</div>}
      <Link
        to={
          isMandateLink
            ? generatePath(MANDATE_PAGE_ROUTE, { id: item.slug || item.mandateInfo?.id || '', lang })
            : generatePath(COMPANY_PAGE_ROUTE, { id: item.slug || item._id, lang })
        }
        className={cn(css.slideInner, isUpvoteDisabled && css.isUpvoteDisabled)}
      >
        <img
          src={imgixUrl(item.decorImage || item.mainImage, { auto: 'compress' })}
          alt={item.name}
          className={css.mainImage}
        />
        {/* {!isUpvoteDisabled && (
          <div className={css.upvote}>
            <span>{item.rating}</span>
            <RatingUpButton size="small" id={item._id} onClick={() => console.info('Upvote Clicked')} />
          </div>
        )} */}
        <div className={css.bottom}>
          <h6 dangerouslySetInnerHTML={{ __html: item.name }} />
          <p dangerouslySetInnerHTML={{ __html: item.subTitle }} />
          <span className={css.button}>
            <PlayIcon size={size === SIZE_TYPE.L ? SIZE_TYPE.M : size} className={css.iconPlay} />
            <span>{buttonLabel}</span>
          </span>
        </div>
      </Link>
    </div>
  );
};

export default DoubleImageSlide;
